import Vue from 'vue';
import Router from 'vue-router';
import Login from './components/Login.vue';
import Home from './components/Home.vue';
import Index from './components/Index.vue';
import Contact from './components/Contact.vue';
import Agreement from './components/Agreement.vue';
import NewsDetail from './components/NewsDetail.vue';
import VideoPlay from './components/VideoPlay.vue';
import RelevantNotice from './components/RelevantNotice.vue';
import OnlineDrama from './components/OnlineDrama.vue';

import Welcome from './components/Welcome.vue';
import Users from './components/user/Users.vue';
import Rights from './components/power/Rights.vue';
import Roles from './components/power/Roles.vue';
import Cate from './components/goods/Cate.vue';
import Params from './components/goods/Params.vue';
import GoodsList from './components/goods/List.vue';
import Add from './components/goods/Add.vue';

Vue.use(Router);

const router = new Router({
  routes: [
    { path: '/', redirect: '/index' },
    // { path: '/', redirect: '/contact' },
    { path: '/index', component: Index },
    { path: '/login', component: Login },
    { path: '/contact', component: Contact },
    { path: '/agreement', component: Agreement },
    { path: '/onlineDrama', component: OnlineDrama },
    { path: '/relevantNotice', component: RelevantNotice },
    { path: '/newsDetail/:newsId', component: NewsDetail, props: true },
    { path: '/videoPlay/:videoId', component: VideoPlay, props: true },

    {
      path: '/home',
      component: Home,
      redirect: '/welcome',
      children: [
        { path: '/welcome', component: Welcome },
        { path: '/users', component: Users },
        { path: '/rights', component: Rights },
        { path: '/roles', component: Roles },
        { path: '/categories', component: Cate },
        { path: '/params', component: Params },
        { path: '/goods', component: GoodsList },
        { path: '/goods/add', component: Add },
      ],
    },
  ],
});

// 挂载路由导航守卫
// router.beforeEach((to, from, next) => {
//   // to 将要访问的路径
//   // from 代表从哪个路径跳转而来
//   // next 是一个函数，表示放行
//   //     next()  放行    next('/login')  强制跳转

//   if (to.path === '/login') return next()
//   // 获取token
//   const tokenStr = window.sessionStorage.getItem('token')
//   if (!tokenStr) return next('/login')
//   next()
// })

export default router;
